import emitterEvents from "./emitterEvents";
import commonConfig from "../config/common";

const {
  globalKeys: { asosKey, eventBusKey },
} = commonConfig;

export const emit = async (action, store) => {
  if (action && Object.keys(emitterEvents).includes(action.type)) {
    const result = await emitterEvents[action.type](action, store.getState());
    if (Array.isArray(result)) {
      window[asosKey][eventBusKey].emit(...result);
    }
  }
};
